var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"kp-root-panel-bg"},[(!_vm.routeNeedsAuth)?_c('router-view'):_c('div',[_vm._v("... redirect in progress ...")])],1),_c('Toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }